<template>
  <div id="app" :class="deviceType">
    <component :is="currentLayout" v-if="currentLayout"/>
    <div v-else>Loading...</div>
  </div>
</template>

<script>
import {defineAsyncComponent, onMounted, onUnmounted, ref, watch} from 'vue'
import {getDeviceType} from '@/utils/device'

// 防抖函数
function debounce(func, delay) {
  let timer = null
  return function () {
    const context = this
    const args = arguments
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(context, args)
    }, delay)
  }
}

export default {
  name: 'about',
  setup() {
    const deviceType = ref(getDeviceType())
    const currentLayout = ref(null)

    // 动态加载布局组件（Vue 3 推荐方式）
    const loadLayoutComponent = (type) => {
      currentLayout.value = defineAsyncComponent(() =>
          import(`@/views/about/${type}/index.vue`)
      )
    }

    // 监听窗口变化
    const handleResize = debounce(() => {
      deviceType.value = getDeviceType()
    }, 300)

    // 初始化加载
    loadLayoutComponent(deviceType.value)

    // 响应式监听设备类型变化
    watch(deviceType, (newVal) => {
      loadLayoutComponent(newVal)
    })

    // 生命周期钩子
    onMounted(() => {
      window.addEventListener('resize', handleResize)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize)
    })

    return {
      deviceType,
      currentLayout
    }
  }
}
</script>

<style scoped>
/* 样式与Vue 2版本保持一致 */
#app {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  font-family: PingFang SC;
  color: #1c1f24;
  background-color: #ffffff;

  &.mobile { /* 移动端样式 */
  }

  &.pc { /* PC端样式 */
    min-width: 16.666667vw;
  }
}
</style>